import React from 'react';
import DataTable from '../../../baseApp/shared/components/table/DataTable';
import {I18n} from 'react-redux-i18n';
import SearchForm from './../../../baseApp/shared/components/searchForm/SearchForm';
import {parkingTableSearchFields} from "./SearchFields";
import {appModules} from '../../../baseApp/roles/components/UserHasPermission';

const ParkingSlotTable = ({
    loading = false,
    error = undefined,

    handleSortChanged,
    handleSearchSubmit,
    handleSearchClear,
    handleSearchFieldChange,

    searchFieldsValues,
    searchFieldsData,

    data = [],
    totalElements,
    pages=0,
    pageSize,
    currentPage=0,
    sort: {
        property = "",
        direction = "ASC"
    },

    onPageChange,
    onPageSizeChange,

    handleParkingTableSlotClicked = () => {}
}) => {
    const columns = [{
        Header: I18n.t('parking.table.parkingFloor'),
        id: "id",
        accessor: entry => <span>{entry.parent.name}</span>,
        sortable: true
    }, {
        Header: I18n.t("parking.table.slotId"),
        id: 'number',
        accessor: entry => <span>{entry.name}</span>,
        sortable: true
    }, {
        Header: I18n.t("parking.table.category"),
        id: 'category',
        accessor: entry => <span> {entry.category ? entry.category.name : '- - -'} </span>,
        sortable: true
    }, {
        Header: I18n.t('parking.table.status'),
        id: 'status',
        accessor: entry => <span>{I18n.t('parking.status.' + (entry.status).toLowerCase())}</span>,
        sortable: true
    }, {
        Header: I18n.t("parking.table.timestamp"),
        id: 'lastUpdateTimestamp',
        accessor: entry => <span>{entry.lastUpdateTimestamp? entry.lastUpdateTimestamp : '- - -'}</span>,
        sortable: true
    }];

    return (
      <div className="table-info-wrapper page_background">
        <SearchForm
          content={parkingTableSearchFields(
            searchFieldsValues,
            searchFieldsData,
          )}

          handleFieldChange={handleSearchFieldChange}
          handleClear={handleSearchClear}
          handleSubmit={handleSearchSubmit}
          hideAddButton={true}
          hideUniversalSearch={true}
          appModule={appModules.PARKING}
        />
        <div className="table-info-table">
          <DataTable
            data={data}

            sortProperty={property}
            sortDirection={direction}
            onSortChanged={handleSortChanged}

            pages={pages}
            selectedPage={currentPage}
            pageSize={pageSize}
            totalElements={totalElements}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            pageSizeOptions={[10, 20, 50]}

            columns={columns}
            onRowClick={handleParkingTableSlotClicked}
          />
        </div>
      </div>
    );
};

export default ParkingSlotTable;